var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 97.803,
    height: 28.609,
    viewBox: "0 0 283.465 82.894",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#005775",
    d: "M1.308,81.586C0.476,81.586,0,81.11,0,80.277V25.085c0-0.714,0.238-1.308,0.951-1.665       c6.78-2.855,14.631-4.639,22.838-4.639c15.94,0,26.764,7.494,26.764,25.693v35.804c0,0.832-0.475,1.308-1.427,1.308h-7.018       c-0.832,0-1.308-0.476-1.308-1.308V44.711c0-12.371-6.304-17.129-17.01-17.129c-4.996,0-10.348,0.951-14.036,2.141v50.554       c0,0.832-0.476,1.308-1.427,1.308H1.308z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005775",
    d: "M114.307,54.108c0,0.951-0.476,1.427-1.308,1.427H74.102v4.996c0,8.921,6.661,13.679,15.464,13.679       c8.207,0,13.798-3.212,18.199-6.661c0.714-0.476,1.427-0.357,1.903,0.357l3.449,4.52c0.596,0.714,0.476,1.308-0.238,1.903       c-5.947,4.996-13.56,8.564-23.551,8.564c-12.847,0-25.099-7.375-25.099-22.362V42.451c0-16.296,12.133-23.671,25.217-23.671       c12.966,0,24.861,7.375,24.861,23.671V54.108z M89.446,27.583c-8.921,0-15.344,4.639-15.344,14.869v4.996h30.689v-4.996       C104.792,32.34,98.13,27.583,89.446,27.583z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005775",
    d: "M148.799,73.854c1.308,0,3.568-0.119,5.709-0.238c0.952,0,1.428,0.476,1.428,1.308v6.304       c0,0.714-0.358,1.308-1.19,1.427c-2.141,0.119-4.876,0.238-6.423,0.238c-11.896,0-20.698-6.423-20.698-21.054V6.409       c0-0.951,0.476-1.427,1.427-1.427h6.186c0.714,0,1.189,0.476,1.308,1.308l0.832,14.393h15.464c0.832,0,1.308,0.476,1.308,1.308       v5.947c0,0.952-0.476,1.427-1.308,1.427h-15.464v31.998C137.379,69.215,141.423,73.854,148.799,73.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005775",
    d: "M186.267,82.894c-8.207,0-16.416-2.379-23.553-7.613c-0.714-0.476-0.714-1.189-0.356-1.903       l3.211-5.471c0.476-0.833,1.07-0.951,1.903-0.357c5.71,4.282,12.252,6.661,19.033,6.661c7.969,0,14.036-3.331,14.036-9.516       c0-6.661-7.375-8.207-14.036-9.516c-8.565-1.784-23.196-5.115-23.196-18.913c0-12.133,11.538-17.486,23.434-17.486       c7.493,0,14.155,1.903,20.696,5.59c0.834,0.357,0.952,1.07,0.476,1.784l-3.211,5.352c-0.356,0.714-1.07,0.952-1.784,0.476       c-4.876-2.617-10.706-4.401-16.653-4.401c-8.327,0-13.323,3.33-13.323,8.683c0,6.542,7.018,8.326,15.464,9.992       c9.516,1.903,22.006,4.639,22.006,17.962C210.414,76.352,200.184,82.894,186.267,82.894z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#03bfef",
    cx: 241.95,
    cy: 13.832,
    r: 13.832
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03bfef",
    cx: 271.292,
    cy: 13.832,
    r: 8.852
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03bfef",
    cx: 271.292,
    cy: 43.107,
    r: 12.172
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03bfef",
    cx: 241.95,
    cy: 72.382,
    r: 10.512
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNets);
export default __webpack_public_path__ + "static/media/nets.39b781d8d1b7708a3a139837b31949ba.svg";
export { ForwardRef as ReactComponent };